import { defineStore } from 'pinia'

export const MenuDrawer = defineStore('menu_drawer', {
    state: () => {
        return { menu_drawer: false }
    },
    actions: {
        get() {
            return this.menu_drawer
        },
        set(data) {
            this.menu_drawer = data
        }
    },
})